import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import {FormBuilder, Validators} from '@angular/forms';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {take} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-select-default-template-dialog',
  templateUrl: './select-default-template-dialog.component.html',
  styleUrls: ['./select-default-template-dialog.component.scss']
})
export class SelectDefaultTemplateDialogComponent implements OnInit, IDialogView, OnDestroy {
  inputForm: any;
  data: DialogModel;
  flowTemplates: any[];
  isFromSetWorkFlow: boolean;
  oicReturnFilterOptions: any[];
  skipReturnsWithFlowDisplayText: string;
  selectedFilterOption: string;
  skipReturnsWithFlow: true;
  applyToNewReturns: false;
  applyToNewReturnsText: string;
  private ngUnsubscribe = new Subject<void>();

  constructor(private formBuilder: FormBuilder,
              private platformQueryService: PlatformQueryService,
  ) {
    this.skipReturnsWithFlow = true;
    this.inputForm = this.formBuilder.group({
      flowTemplate: ['', Validators.required],
      radio: [''],
      chkSkipReturnsWithFlow: [this.skipReturnsWithFlow],
      chkApplyToNewReturns: [this.applyToNewReturns]
    });
    this.isFromSetWorkFlow = false;
    this.oicReturnFilterOptions = [];
  }

  ngOnInit(): void {
    const query = new PlatformQuery();
    query.name = 'FlowTemplateQuery';
    query.api = 'FlowApi';

    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      this.flowTemplates = response.fieldValues['FlowTemplates'];
    });
    if (this.data.input.isFromSetWorkFlow) {
      this.isFromSetWorkFlow = this.data.input.isFromSetWorkFlow;
      this.oicReturnFilterOptions = this.data.input.oicReturnFilterOptions;
      this.selectedFilterOption = this.oicReturnFilterOptions[0].key;
      this.skipReturnsWithFlowDisplayText = this.data.input.skipReturnsWithFlowDisplayText;
      this.applyToNewReturnsText = this.data.input.applyToNewReturnsText;
      const flowTemplateControl = this.inputForm.controls['flowTemplate'];
      if (flowTemplateControl && this.data.input.defaultWorkflowTemplateId) {
        flowTemplateControl.setValue(this.data.input.defaultWorkflowTemplateId);
      }

    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onOkClicked(): boolean {
    const flowTemplateControl = this.inputForm.controls['flowTemplate'];
    flowTemplateControl.markAsTouched();

    if (flowTemplateControl.hasError('required')) {
      return false;
    }

    this.data.input['flowTemplateId'] = flowTemplateControl.value;
    if (this.isFromSetWorkFlow) {
      this.data.input['selectedFilterOption'] = this.selectedFilterOption;
      this.data.input['skipReturnsWithFlow'] = this.skipReturnsWithFlow;
      this.data.input['applyToNewReturns'] = this.applyToNewReturns;
    }
    return true;
  }
}
